/* _customled-find-my-relay-card.js — Custom LED owned
 *
 * Injects a "Find My Relay" CTA card as the FIRST item in the collection product
 * grid on a fixed allowlist of BROAD "all-products" collections (per-make landings,
 * all, best-selling, newest, on-sale, accessories). Shown regardless of filter state
 * (page 1 only, so it isn't repeated atop every paginated page).
 *
 * Why: relays are deliberately kept OUT of the fitment metafields (their 300+ model
 * lists would crowd out the filters), so a bike-shopper browsing a broad collection
 * can't surface relays via the facets — this card taps through to the dedicated
 * relay-compatibility finder. NOT shown on the flasher-relays collection (it has its
 * own finder button) or on specific-product collections (their PDPs cross-sell the
 * relay via recommended accessories).
 *
 * Owned, zero vendor edits. Loaded + gated to collection templates by
 * snippets/_customled-stylesheets.liquid, which also sets window.CUSTOMLED_RELAY_URL
 * (locale-correct finder URL) and window.CUSTOMLED_RELAY_STRINGS (localized copy).
 *
 * Re-runs on AJAX grid re-renders (filter/sort/pagination) via a MutationObserver and
 * on history popstate. Idempotent: never double-inserts.
 */
(function () {
  if (!/(^|\/)collections\//.test(location.pathname)) return;
  var RELAY_URL = window.CUSTOMLED_RELAY_URL || '/pages/motorcycle-led-flasher-relay-compatibility';

  // Broad "all-products" collections where the relay finder is a useful CTA.
  // (Relay collection excluded — has its own finder button. Specific-product
  // collections excluded — their PDPs cross-sell the relay via recommended accessories.)
  var ALLOWED = {
    'all': 1,
    'products-for-honda-motorcycles': 1,
    'products-for-husqvarna-motorcycles': 1,
    'products-for-ktm-motorcycles': 1,
    'products-for-suzuki-motorcycles': 1,
    'products-for-triumph-motorcycles': 1,
    'products-for-yamaha-motorcycles': 1,
    'custom-led-products-for-ducati-motorcycles': 1,
    'accessories-for-kawasaki-motorcycles': 1,
    'best-selling-products-custom-led': 1,
    'newest-products': 1,
    'motorcycle-led-product-sale-custom-led': 1,
    'led-accessories': 1
  };

  function allowedCollection() {
    // pathname may be locale-prefixed (/fr/collections/…, /es/collections/…)
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    return !!(m && ALLOWED[m[1]]);
  }
  function firstPage() {
    var m = location.search.match(/[?&]page=(\d+)/);
    return !m || m[1] === '1';
  }
  function shouldShow() {
    return allowedCollection() && firstPage();
  }

  function buildCard() {
    // M1.21: strings come from the loader (locale keys via window.CUSTOMLED_RELAY_STRINGS)
    // so the card renders localized on /es and /fr; EN literals are the fallback.
    // dec(): Shopify's t-filter HTML-escapes non-_html keys, so apostrophes etc.
    // arrive as entities inside the JSON — decode via detached textarea (inert).
    function dec(s) {
      if (!s || s.indexOf('&') === -1) return s;
      var t = document.createElement('textarea');
      t.innerHTML = s;
      return t.value;
    }
    var R = window.CUSTOMLED_RELAY_STRINGS || {};
    var S = { eyebrow: dec(R.eyebrow), title: dec(R.title), text: dec(R.text), button: dec(R.button) };
    var li = document.createElement('li');
    li.className = 'grid-item customled-find-relay-li';
    li.setAttribute('data-customled-find-relay', '');
    var card = document.createElement('div');
    card.className = 'customled-find-relay-card';
    function span(cls, text) {
      var el = document.createElement('span');
      el.className = cls;
      el.textContent = text;
      return el;
    }
    card.appendChild(span('customled-find-relay-eyebrow', S.eyebrow || 'Need a flasher relay?'));
    card.appendChild(span('customled-find-relay-title', S.title || 'Find the right LED flasher relay for your motorcycle'));
    card.appendChild(span('customled-find-relay-text', S.text || 'Relays fit hundreds of models — use the compatibility finder to get your exact match.'));
    var a = document.createElement('a');
    a.className = 'button customled-find-relay-btn';
    a.href = RELAY_URL;
    a.textContent = S.button || 'Find My Relay';
    card.appendChild(a);
    li.appendChild(card);
    return li;
  }

  function sync() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var existing = grid.querySelector('[data-customled-find-relay]');
    if (shouldShow()) {
      if (!existing) grid.insertBefore(buildCard(), grid.firstElementChild);
    } else if (existing) {
      existing.remove();
    }
  }

  function init() {
    sync();
    // <facet-filters-form> AJAX-replaces the CONTENTS of #ProductGridContainer on every
    // filter/sort/page change, so observe that STABLE container (not the grid/.collection
    // inside it, which get destroyed). Re-inject into the fresh grid each time.
    var target = document.getElementById('ProductGridContainer') ||
                 document.getElementById('MainContent') || document.body;
    new MutationObserver(sync).observe(target, { childList: true, subtree: true });
    window.addEventListener('popstate', sync); // back/forward + pushState filter/page changes
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
